// §34.5 / §9.1 — Diff's registration stub.
//
// **Manifest and thunk only** (D-511); the chunk is `lazy.Diff-<hash>.js`, excluded from the
// precache by the same exact-prefix rule as the Arcade's titles.
//
// It holds **no capability** — everything it does goes through `HangarAPI` (§34.1's default), which
// is why it is registered with no argument. It also registers **no file types**, deliberately:
// §34.5 calls it "a tool, not a default", and a diff of one file is not a thing, so there is nothing
// for a double-click to mean.
import type { InProcessApp } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';
import { COPY } from '@/copy';
import { DIFF_WINDOW } from '@/config';

export function createDiffApp(): InProcessApp {
  return createLazyApp({
    app: {
      id: 'diff',
      name: COPY.diff.title,
      category: 'Utilities',
      icon: { glyph: 'file-diff', hue: 268 },
      keywords: ['diff', 'compare', 'changes', 'versions', 'differences'],
      window: { ...DIFF_WINDOW, multiWindow: true },
      // §10.2 — what Explorer's Compare hands it (§34.5). Declared so the delivery is a *contract*
      // rather than a private channel, and so a Share of two texts could reach it later.
      accepts: [{ mime: ['application/x-hangar-diff+json'], action: 'open' }],
    },
    load: () => import('./Diff'),
  });
}
